import { useMemo } from "react"
import { useTranslation } from "react-i18next"

import { Entry } from "shared/types/Entry"
import { AVAILABLE_PROJECT_COLORS } from "shared/types/Project"

import { ParseKeys } from "i18next"

export function useProjectColorOptions(): Entry<string>[] {
  const { t } = useTranslation()

  return useMemo(
    () =>
      AVAILABLE_PROJECT_COLORS.map(projectColor => ({
        value: projectColor,
        label: t(`Color.${projectColor}` as ParseKeys) as string
      })),
    [t]
  )
}
